import { _ as __rest, a as __assign } from './tslib.es6-16156773.js';
import React, { forwardRef } from 'react';
import 'classnames';
import '@alfalab/hooks';
import '../../form-control/esm';
import './utils.js';
import { Field } from './components/field/Component.js';
import { Arrow } from './components/arrow/Component.js';
import 'react-merge-refs';
import { Optgroup } from './components/optgroup/Component.js';
import { OptionsList } from './components/options-list/Component.js';
import './components/checkmark/Component.js';
import { Option } from './components/option/Component.js';
import 'resize-observer';
import '../../popover/esm';
import 'downshift';
import './components/native-select/Component.js';
import { BaseSelect } from './components/base-select/Component.js';

var Select = forwardRef(function (_a, ref) {
    var _b = _a.Arrow, Arrow$1 = _b === void 0 ? Arrow : _b, _c = _a.Field, Field$1 = _c === void 0 ? Field : _c, _d = _a.OptionsList, OptionsList$1 = _d === void 0 ? OptionsList : _d, _e = _a.Optgroup, Optgroup$1 = _e === void 0 ? Optgroup : _e, _f = _a.Option, Option$1 = _f === void 0 ? Option : _f, restProps = __rest(_a, ["Arrow", "Field", "OptionsList", "Optgroup", "Option"]);
    return (React.createElement(BaseSelect, __assign({ ref: ref, Option: Option$1, Field: Field$1, Optgroup: Optgroup$1, OptionsList: OptionsList$1, Arrow: Arrow$1 }, restProps)));
});

export { Select };
